import React from 'react';
import { motion } from 'framer-motion';
export function ImpactShowcase() {
  return <section className="py-20 px-4 bg-[#0a0514] overflow-hidden" data-id="element-172">
      <div className="max-w-5xl mx-auto text-center" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-174">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6 tracking-tight uppercase" data-id="element-175">
            TRANSFORMÁ LO ORDINARIO <br data-id="element-176" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00f0ff] to-[#8b5cf6]" data-id="element-177">
              EN ALGO EXTRAORDINARIO
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-178">
            Con las técnicas de mi libro, vas a pasar de crear muebles comunes a
            piezas de arte tecnológico que dejan a todos sin palabras.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative rounded-[2rem] overflow-hidden shadow-[0_0_50px_rgba(139,92,246,0.3)] border border-white/10" data-id="element-179">
          <img src="https://cdn.magicpatterns.com/uploads/2oWUQ3EnqfC8ty24iCuJTZ/que_las_mesas_tengan_un_202605050306.jpg" alt="Transformación de mesa normal a mesa infinita" className="w-full h-auto object-cover" data-id="element-180" />

          {/* Overlay Labels */}
          <div className="absolute top-6 left-6 bg-black/60 backdrop-blur-md text-white px-4 py-2 rounded-full text-sm font-bold border border-white/20" data-id="element-181">
            ANTES
          </div>
          <div className="absolute top-6 right-6 bg-[#8b5cf6]/80 backdrop-blur-md text-white px-4 py-2 rounded-full text-sm font-bold border border-white/20 shadow-[0_0_15px_rgba(139,92,246,0.5)]" data-id="element-182">
            DESPUÉS
          </div>

          {/* Bottom Impact Text */}
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-8 pt-20" data-id="element-183">
            <p className="text-white text-lg md:text-2xl font-bold italic" data-id="element-184">
              "El límite es tu imaginación..."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}